module.exports = __webpack_public_path__ + "ee5c7a60525ab3be659666a0cafd33e2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/chrome.png
 ** module id = 28
 ** module chunks = 0
 **/